import {lazy} from "react"
export const Complain=lazy(()=>import("./complain"));
export const Suggestion=lazy(()=>import("./suggestion"));
export const QuotationApproval=lazy(()=>import("./quotationApproval"));